import { Directive, ElementRef, Renderer2, OnInit, Input, DestroyRef } from "@angular/core";
import { takeUntilDestroyed } from "@angular/core/rxjs-interop";
import { DeviceService } from "../service/device.service";

@Directive({
  selector: "[appDisableLightTheme]",
  standalone: true,
})
export class DisableLightThemeDirective implements OnInit {
  @Input() public enableLightTheme: boolean = false;
  private readonly _className = "disable-light-theme";

  constructor(
    private _el: ElementRef,
    private _deviceService: DeviceService,
    private _renderer: Renderer2,
    private _destroyRef: DestroyRef,
  ) {}

  public ngOnInit(): void {
    this._deviceService
      .isBelow(768)
      .pipe(takeUntilDestroyed(this._destroyRef))
      .subscribe((isMobile) => {
        const elements = [this._el.nativeElement, ...this._el.nativeElement.querySelectorAll("*")];
        if (isMobile && !this.enableLightTheme) {
          elements.forEach((el: HTMLElement) => this._renderer.addClass(el, this._className));
        } else {
          elements.forEach((el: HTMLElement) => this._renderer.removeClass(el, this._className));
        }
      });
  }
}
